import { render, staticRenderFns } from "./MyCompanyAcceptanceFormsNew.vue?vue&type=template&id=32e08aa4&"
import script from "./MyCompanyAcceptanceFormsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyAcceptanceFormsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports